export const profits = {
  'backoffice.profits.accountsSummary.title': 'Resumen de Ganancias de Cuentas',
  'backoffice.profits.accountsSummary.subtitle': 'Resumen del rendimiento de ganancias en todas sus cuentas de inversión',
  'backoffice.profits.accountsHistory.title': 'Historial de Ganancias de Cuentas',
  'backoffice.profits.accountsHistory.subtitle': 'Datos históricos detallados de ganancias de sus cuentas de inversión',
  'backoffice.profits.commissionsSummary.title': 'Resumen de Comisiones',
  'backoffice.profits.commissionsSummary.subtitle': 'Resumen de sus comisiones de referidos y ganancias',
  'backoffice.profits.commissionsHistory.title': 'Historial de Comisiones',
  'backoffice.profits.commissionsHistory.subtitle': 'Historial detallado de ganancias de comisiones y transacciones',
  'backoffice.profits.commissionsPaymentHistory.title': 'Historial de Pagos de Comisiones',
  'backoffice.profits.commissionsPaymentHistory.subtitle': 'Rastree todos los pagos de comisiones e historial de retiros',
  'backoffice.profits.common.loading': 'Cargando datos de ganancias...',
  'backoffice.profits.common.error': 'Error al cargar información de ganancias',
  'backoffice.profits.common.noData': 'No hay datos de ganancias disponibles',
  'backoffice.profits.common.comingSoon': 'Esta función estará disponible pronto',
  'backoffice.profits.common.placeholder': 'Los detalles de ganancias se mostrarán aquí una vez implementados',
  'backoffice.profits.lifetime.title': 'Ganancias de Cuentas de por Vida',
  'backoffice.profits.lifetime.totalProfit': 'Ganancia Total de por Vida',
  'backoffice.profits.lifetime.accountProfit': 'Ganancia de Cuenta',
  'backoffice.profits.lifetime.programProfit': 'Ganancia del Programa',
  'backoffice.profits.lastMonth.title': 'Ganancias de Cuentas del Mes Pasado',
  'backoffice.profits.lastMonth.totalProfit': 'Ganancia Total del Mes Pasado',
  'backoffice.profits.lastMonth.accountProfit': 'Ganancia de Cuenta',
  'backoffice.profits.lastMonth.programProfit': 'Ganancia del Programa',
  'backoffice.profits.overtime.title': 'Ganancias de Cuentas a lo Largo del Tiempo',
  'backoffice.profits.overtime.chartTitle': 'Historial de Ganancias (Últimos 12 Meses)',
  'backoffice.profits.breakdown.title': 'Desglose por Cuenta',
  'backoffice.profits.breakdown.accountNumber': 'Número de Cuenta',
  'backoffice.profits.breakdown.broker': 'Corredor',
  'backoffice.profits.breakdown.balance': 'Saldo',
  'backoffice.profits.breakdown.accountProfit': 'Ganancia de Cuenta',
  'backoffice.profits.breakdown.programProfit': 'Ganancia del Programa',
  'backoffice.profits.breakdown.totalProfit': 'Ganancia Total',
  'backoffice.profits.breakdown.noAccounts': 'No se encontraron cuentas',
  'backoffice.profits.history.filters.account': 'Cuenta',
  'backoffice.profits.history.filters.allAccounts': 'Todas las Cuentas',
  'backoffice.profits.history.filters.dateFrom': 'Fecha Desde',
  'backoffice.profits.history.filters.dateTo': 'Fecha Hasta',
  'backoffice.profits.history.filters.apply': 'Aplicar Filtros',
  'backoffice.profits.history.filters.reset': 'Restablecer',
  'backoffice.profits.history.table.title': 'Historial de Ganancias',
  'backoffice.profits.history.table.account': 'Cuenta',
  'backoffice.profits.history.table.period': 'Período',
  'backoffice.profits.history.table.accountProfit': 'Ganancia de Cuenta',
  'backoffice.profits.history.table.exportCSV': 'Exportar CSV',
  'backoffice.profits.history.pagination.showing': 'Mostrando',
  'backoffice.profits.history.pagination.of': 'de',
  'backoffice.profits.history.pagination.results': 'resultados',
  'backoffice.profits.history.pagination.page': 'Página',
  'backoffice.profits.history.pagination.previous': 'Anterior',
  'backoffice.profits.history.pagination.next': 'Siguiente',
  'backoffice.profits.history.pagination.loadMore': 'Cargar Más',
  'backoffice.profits.commissions.lifetime.title': 'Comisiones de por Vida',
  'backoffice.profits.commissions.lastMonth.title': 'Comisiones del Mes Pasado',
  'backoffice.profits.commissions.balance.title': 'Saldo Actual',
  'backoffice.profits.commissions.balance.lastUpdated': 'Última actualización:',
  'backoffice.profits.commissions.paid.title': 'Total Pagado',
  'backoffice.profits.commissions.overtime.title': 'Comisiones a lo Largo del Tiempo',
  'backoffice.profits.commissionsHistory.filters.level': 'Nivel',
  'backoffice.profits.commissionsHistory.filters.allLevels': 'Todos los Niveles',
  'backoffice.profits.commissionsHistory.filters.levelNumber': 'Nivel {{level}}',
  'backoffice.profits.commissionsHistory.table.title': 'Historial de Comisiones',
  'backoffice.profits.commissionsHistory.table.date': 'Fecha',
  'backoffice.profits.commissionsHistory.table.level': 'Nivel',
  'backoffice.profits.commissionsHistory.table.levelCompany': 'Empresa',
  'backoffice.profits.commissionsHistory.table.levelLeftover': 'Restante',
  'backoffice.profits.commissionsHistory.table.commission': 'Comisión',
  'backoffice.profits.commissionsHistory.table.levelNumber': 'Nivel {{level}}',
  'backoffice.profits.commissionsPaymentHistory.filters.status': 'Estado',
  'backoffice.profits.commissionsPaymentHistory.filters.allStatuses': 'Todos los Estados',
  'backoffice.profits.commissionsPaymentHistory.filters.paymentMethod': 'Método de Pago',
  'backoffice.profits.commissionsPaymentHistory.filters.allPaymentMethods': 'Todos los Métodos de Pago',
  'backoffice.profits.commissionsPaymentHistory.filters.crypto': 'Crypto',
  'backoffice.profits.commissionsPaymentHistory.filters.bank': 'Transferencia Bancaria',
  'backoffice.profits.commissionsPaymentHistory.table.title': 'Historial de Pagos de Comisiones',
  'backoffice.profits.commissionsPaymentHistory.table.date': 'Fecha',
  'backoffice.profits.commissionsPaymentHistory.table.paymentMethod': 'Método de Pago',
  'backoffice.profits.commissionsPaymentHistory.table.status': 'Estado',
  'backoffice.profits.commissionsPaymentHistory.table.amount': 'Cantidad',
  'backoffice.profits.commissionsPaymentHistory.table.exportCSV': 'Exportar CSV',
  'backoffice.profits.commissionsPaymentHistory.status.paid': 'Pagado',
  'backoffice.profits.commissionsPaymentHistory.status.completed': 'Completado',
  'backoffice.profits.commissionsPaymentHistory.status.pending': 'Pendiente',
  'backoffice.profits.commissionsPaymentHistory.status.cancelled': 'Cancelado',
  'backoffice.profits.commissionsPaymentHistory.status.failed': 'Fallido',
  'backoffice.profits.commissionsPaymentHistory.status.rejected': 'Rechazado',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.crypto': 'Crypto',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.bank': 'Transferencia Bancaria',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.unknown': 'Desconocido'
};
